import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-bar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.withoutStepOne)
      ? (_openBlock(), _createBlock(_component_Step, {
          key: 0,
          state: _ctx.isActive(1),
          number: 1,
          title: _ctx.$t('dashboard.parametrable.modale.widget.stepbar.etape1'),
          id: "creation-widget-step-bar"
        }, null, 8, ["state", "title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Step, {
      state: _ctx.isActive(2),
      number: _ctx.withoutStepOne ? 1 : 2,
      title: _ctx.$t('dashboard.parametrable.modale.widget.stepbar.etape2')
    }, null, 8, ["state", "number", "title"]),
    _createVNode(_component_Step, {
      state: _ctx.isActive(3),
      number: _ctx.withoutStepOne ? 2 : 3,
      title: _ctx.$t('dashboard.parametrable.modale.widget.stepbar.etape3')
    }, null, 8, ["state", "number", "title"])
  ]))
}